module.exports = __webpack_public_path__ + "img/img-main-bg01.ddc05d44.png";